import { createWebHashHistory, createRouter } from "vue-router";

export const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/',
            name: '',
            component: () => import('./components/gift/Subscription.vue')
        },
        {
            path: '/thank-you',
            name: '',
            component: () => import('./components/gift/ThankYou.vue')},
        {
            path: '/gift-stop',
            name: '',
            component: () => import('./components/gift/Stop.vue')},
        {
            path: '/gift-thank-you/:gifteeName?',
            name: '',
            component: () => import('./components/gift/ThankYou.vue'),
            props: true
        },

        {path: "/:catchAll(.*)", redirect: '/'},
    ]
})

export default router
